import * as React from 'react';
import InputHandler from 'Components/InputHandler';
import type { IExtendedSearchField } from '../ExtendedSearchField';
import type { TESSearchFields } from '../../definitions';
import { updateExtendedSearchMinMax } from '../../functions/utils';

const LeddField = ({ searchFields, onChange, value }: IOwnProps): React.JSX.Element => {
  const handleChange = (values: TOnChangeValues): void => {
    const thisName = Object.keys(values)[0];
    if (!thisName) return;
    const thisValue = values[thisName];
    onChange({
      currentLEDD: updateExtendedSearchMinMax(searchFields, 'currentLEDD', thisValue, thisName, 'LEDD'),
    });
  };

  return (
    <React.Fragment>
      {['minLEDD', 'maxLEDD'].map((name, i) => (
        <React.Fragment key={i}>
          <InputHandler
            type="NumberField"
            editing={true}
            name={name}
            formData={{
              onChange: handleChange,
              document: {
                [name]: value === 'noCropping' ? undefined : value?.[name as keyof typeof value],
              },
            }}
            min={0}
            placeholder={`extendedSearch.${name}Placeholder`}
            width={9}
          />
          {i === 0 && ' - '}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

interface IOwnProps extends Pick<IExtendedSearchField, 'searchFields' | 'onChange'> {
  value: TESSearchFields[keyof TESSearchFields];
}

export default LeddField;
